import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import isConsumer from "owa-session-store/lib/utils/isConsumer";
import { isTeamsFeatureEnabled } from "owa-teams-policies-store/lib/selectors/isTeamsFeatureEnabled";
import { isTeamsPoliciesFetchNotStarted } from "owa-teams-policies-store/lib/selectors/isTeamsPoliciesFetchNotStarted";
import { lazyGetTeamsPolicies } from "owa-teams-policies";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";
import { getApp } from "owa-config";
import { TeamsPoliciesScenario } from "owa-teams-policies-store/lib/store/schema";
import { isPresenceLicenseEnabled } from "./isPresenceLicenseEnabled";

const isPresenceSupported = (mailboxInfo: MailboxInfo): boolean => {
    if (!isGlobalFeatureEnabled("mon-presence-licensecheck") && isTeamsPoliciesFetchNotStarted()) {
        // Trigger fetching of teams policies if not already started
        lazyGetTeamsPolicies.importAndExecute(TeamsPoliciesScenario.Presence, mailboxInfo);
    }
    
    return ((isGlobalFeatureEnabled("mon-presence") || isPlacesApp()) &&
        !isConsumer(undefined, mailboxInfo) &&
        isServiceRequestSupportedForMailbox(mailboxInfo) &&
        (isGlobalFeatureEnabled("mon-presence-licensecheck")
            ? isPresenceLicenseEnabled(mailboxInfo)
            : isTeamsFeatureEnabled()));
};

function isPlacesApp() {
    return getApp() === "Places";
}

export default isPresenceSupported;
